<template>
    <li class="activity-item">
        <i :class="bgclass">{{title}}</i>
        <div>
            <span class="activity-name">{{name}}</span>
            <span class="activity-date">{{date}}</span>
        </div>
    </li>
</template>
<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            date: {
                type: String,
                required: true
            },
            bgclass: {
                type: String,
                required: true
            }
        },
        computed: {
            title() {
                return this.name.substr(0, 2);
            }
        }
    };
</script>
<style lang="postcss">
.activity-item {
  display: flex;
  margin-bottom: 25px;
  .first {
    background-image: url(https://p0.meituan.net/codeman/23ec88a66785bf82678509a9060faab815674.png);
  }
  .second {
    background-image: url(https://p1.meituan.net/codeman/e2574df0872d5dc507aad5e37f444fb915273.png);
  }
  cursor: pointer;
  > i {
    flex: 0 0 68px;
    width: 68px;
    height: 47px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: 68px 47px;
    color: white;
    text-align: center;
    font-weight: 600;
    line-height: 47px;
    letter-spacing: 3px;
  }
  > div {
    margin-left: 15px;
    flex: 1 0 auto;
    .activity-name {
      display: block;
      color: #333d48;
      line-height: 20px;
      margin-bottom: 4px;
      &:hover {
        color: #3dc6b6;
      }
    }
    .activity-date {
      display: block;
      font-size: 12px;
      color: #93999f;
      line-height: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ActiveItem.vue?7e9a6dd4